module.exports = __webpack_public_path__ + "img/recordRun.43b4b3fa.png";